import apiService from '@/api/apiService';

export const getVersion = async (id) => {
    const url = `/api/admin/balance/version/${id}`;

    return apiService.GET(url);
};
